// removed by extract-text-webpack-plugin
module.exports = {"black":"#0a0a0a","blackContrast":"#ffffff","white":"#ffffff","whiteContrast":"#0a0a0a","primaryColor":"#423393","primaryContrast":"#ffffff"};